import { ArrowRightIcon } from "../kits/Icons/Icons";
import ColorSchema from "../../assets/kits/colors";
import { CustomInput } from "../kits/inputs/Input";
import CustomButton from "../kits/custom-button/CustomButton";
import "./InfoFinancial.scss";
export default function InfoFinancial() {
  return (
    <div className="p-InfoFinancial">
      <div className="d-flex justify-content-start pd-y-12 pd-x-20  border-0 ">
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            window.history.back();
          }}
        >
          <ArrowRightIcon></ArrowRightIcon>
        </div>
        <div className="title-h3-b mr-r-8">اطلاعات مالی</div>
      </div>
      <div className="mr-t-16 pd-y-14 mr-x-16  pd-x-16 section-one">
        <div style={{ color: "#4B5563" }} className="txt-t2-l">
          برای تغییر اطلاعات مالی با پشتیبانی سبدی تماس بگیرید.
        </div>
      </div>
      <div className="mr-x-16">
        <div className="mr-t-24">
          {" "}
          <CustomInput
            title="شماره کارت"
            placeholder="۶۰۳۷-۹۹۷۱-۵۰۳۲-۱۰۵۰"
          ></CustomInput>
        </div>
        <div className="mr-t-24">
          {" "}
          <CustomInput
            title="شماره حساب"
            placeholder="۳۱۲۳۴۵۶۷۸۹۰۱۳"
          ></CustomInput>
        </div>
        <div className="mr-t-24">
          {" "}
          <CustomInput
            title="شماره شبا"
            placeholder="IR-۸۷۰۵۷۰۰۲۸۱۸۰۰۱۰۶۵۳۸۹۲۱۰۱"
          ></CustomInput>
        </div>
        <div className="mr-t-24">
          {" "}
          <CustomInput title="نام بانک " placeholder="سپه"></CustomInput>
        </div>
        <div className="mr-t-24">
          {" "}
          <CustomInput
            title="نام دارنده حساب "
            placeholder="اصغر اکبرزاده"
          ></CustomInput>
        </div>
      </div>
      <div className="mr-t-72 mr-x-16">
        <CustomButton size="large" className=" w-100">
          <span className="title-h4-m">تماس با پشتیبانی</span>
        </CustomButton>
      </div>
    </div>
  );
}
